import { LayoutEditorShell } from '../../../lib/form-layout/LayoutEditorShell';
import {
  CONTRACT_FORM_FIELDS,
  CONTRACT_FORM_FIELD_NAMES,
  CONTRACT_DEFAULT_LAYOUT,
  type ContractFormContext,
} from '../../../lib/form-layout/contract-fields';
import {
  useAdminActiveContractLayout,
  useUpdateContractFormLayout,
} from '../../../queries/contract-form-layout';
import type { ContractInputSchema } from '../../../lib/schemas';

/**
 * Thin wrapper around LayoutEditorShell that wires the contract-form's
 * registry / queries / preview context.
 */
export function ContractFormLayoutEditor() {
  // Pre-populate the preview's `contract_type` so the conditional ROW
  // dimensions render in the live preview.
  const previewDefaults: ContractInputSchema = {
    contract_type: 'row',
    status: 'draft',
    title: '',
    contract_number: null,
    effective_date: null,
    execution_date: null,
    expiration_date: null,
    termination_date: null,
    renewal_notice_date: null,
    recorded: false,
    recording_state: null,
    recording_county: null,
    recording_volume: null,
    recording_page: null,
    recording_instrument_number: null,
    recording_date: null,
    consideration_amount: null,
    consideration_currency: 'USD',
    consideration_notes: null,
    row_use: null,
    row_width_feet: null,
    row_length_feet: null,
    row_length_rods: null,
    row_pipeline_diameter_inches: null,
    row_pipeline_product: null,
    row_depth_restriction_feet: null,
    row_surface_restoration_required: null,
    township: null,
    range: null,
    section: null,
    block: null,
    lot: null,
    abstract: null,
    survey: null,
    apn: null,
    description: null,
    notes: null,
  };

  const previewContext: ContractFormContext = {};

  return (
    <LayoutEditorShell
      title="Contract form layout"
      breadcrumbLabel="Contract form layout"
      registry={CONTRACT_FORM_FIELDS}
      allNames={CONTRACT_FORM_FIELD_NAMES}
      defaultLayout={CONTRACT_DEFAULT_LAYOUT}
      useActive={useAdminActiveContractLayout}
      useUpdate={useUpdateContractFormLayout}
      previewDefaults={previewDefaults}
      previewContext={previewContext}
    />
  );
}
